import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import HeroSkinForm from './HeroSkinForm';
// import { initialValues  } from './initialValues-testing';
import { showHeroSkinApi, updateHeroSkinApi, clearEditedHeroSkin } from './heroSkinSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function HeroSkinUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.heroSkin);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'hero-skins');
        dispatch(updateHeroSkinApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showHeroSkinApi({ navigate, id }));

        return () => dispatch(clearEditedHeroSkin());
    }, []);

    return (
        <HeroSkinForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default HeroSkinUpdate;
